import { useTranslation } from 'react-i18next'
import { Body2, Checkbox, Grid } from '@dhl-ui/components'
import {
  getCheckboxStateProps,
  type CheckboxState,
  type ProductDataTableColumn,
} from '~/common/components/accountnumbers'

type Props = {
  selectAllState: CheckboxState
  onSelectAll: (deselectAll: boolean) => void
  columns: ProductDataTableColumn[]
  disabled: boolean
}

export const Header = ({ selectAllState, onSelectAll, columns, disabled }: Props) => {
  const { t } = useTranslation()
  const columnWidth = 12 / (columns.length || 1)
  const itemSx = {
    paddingTop: 1.25,
    paddingRight: 2,
    paddingBottom: 1.25,
    paddingLeft: 2,
    color: 'grey.600',
    display: 'flex',
    alignItems: 'center',
  }

  return (
    <Grid container>
      {columns.includes('selectAll') && (
        <Grid
          size={{ xs: columnWidth }}
          sx={() => ({
            ...itemSx,
            borderRight: `1px solid grey.300`,
            paddingLeft: 1.5,
            '& .MuiTypography-root': {
              pl: 1,
              pb: 1,
            },
          })}
        >
          <Checkbox
            onChange={(_, checked) => onSelectAll(!checked)}
            {...getCheckboxStateProps(selectAllState)}
            disabled={disabled}
            label={t('admin.selectAll')}
          />
        </Grid>
      )}
      {columns.includes('selectProduct') && (
        <Grid size={{ xs: columnWidth }} sx={{ ...itemSx }}>
          <Body2>{t('admin.accountNumbers.selectProductsHeader')}</Body2>
        </Grid>
      )}
      {columns.includes('selectReturnProduct') && (
        <Grid size={{ xs: columnWidth }} sx={{ ...itemSx }}>
          <Body2>{t('admin.accountNumbers.selectReturnProductsHeader')}</Body2>
        </Grid>
      )}
    </Grid>
  )
}
